module.exports = __webpack_public_path__ + "static/media/transactionTimeOut.eadd3169.svg";